module.exports = __webpack_public_path__ + "static/media/spanish_course_bottom.3611a0fd.png";